<template>
    <v-card>
        <!-- <v-progress-linear v-if="reloading" color="primary" indeterminate rounded absolute top height="3" ></v-progress-linear> -->

        <v-btn v-if="!noDialog" icon top right :large="phoneOnly" class="white" absolute style="top: 8px; right: 8px; z-index: 2;" @click="$emit('close')">
            <v-icon :size="pcOnly ? 21 : 24">mdi-close</v-icon>
        </v-btn>
        <router-link v-if="!noDialog" :to="isStudent ? (classData.is_program_class ? (classData.program ? {name: 'program', params: {id: classData.program.id}} : '') : (classData.enrollment && classData.enrollment.course ? {name: 'course', params: {id: classData.enrollment.course.id}} : '')) : ''">
            <v-img :src="classData.is_program_class ? (classData.program ? classData.program.image_url : '') : (classData.enrollment && classData.enrollment.course ? classData.enrollment.course.image_url : '')" max-height="220" v-ripple="{class: 'black--text'}" />
        </router-link>
        <div class="px-4 pt-3">
            <div class="d-flex justify-space-between w-100">
                
                <div class="d-flex flex-wrap">
                    <v-chip small class="font-weight-medium px-2 me-1 grey lighten-2" label>
                        <span>#{{classData.id}}</span>
                    </v-chip>
                    <v-chip v-if="classData.is_program_class" small outlined class="font-weight-medium me-1" dark color="primary" label>
                        <v-icon size="16" left class="me-1">mdi-account-multiple-outline</v-icon>
                        <span>Group Class</span>
                    </v-chip>

                    <v-chip v-if="classData.rescheduled && classData.status === 'scheduled'" small class="font-weight-medium" dark color="indigo" label>
                        <span v-if="!!classData.waiting_reschedule_request">Reschedule Requested</span>
                        <span v-else>Rescheduled</span>
                    </v-chip>
                    <v-chip v-else-if="!classData.absent && !classData.canceled && !classData.scheduled" small class="font-weight-medium" dark :color="handleStatus(classData.full_status).color" label>{{handleStatus(classData.full_status).text}}</v-chip>
    
                    <v-chip v-if="classData.makeup" small class="font-weight-medium ms-1" dark color="indigo darken-1" label>
                        <v-icon size="17" left class="me-1">mdi-sync</v-icon>
                        <span>Makeup</span>
                    </v-chip>
    
                    <v-chip v-if="classData.absent" small class="font-weight-medium ms-1" dark color="amber darken-1" label>
                        <v-icon small left class="me-1">mdi-close-octagon-outline</v-icon>
                        Absent
                    </v-chip>
                    
                    <v-chip v-if="classData.canceled" small class="font-weight-medium ms-1" dark color="red darken-1" label>
                        <v-icon small left class="me-1">mdi-close</v-icon>
                        Canceled
                    </v-chip>
    
                    <div v-if="classData.payment_status" class="d-flex ms-1">
                        <v-chip v-if="classData.payment_status === 'trial'" small class="font-weight-medium" dark color="teal" label>
                            <span>Trial</span>
                        </v-chip>
                        <v-chip v-else-if="classData.payment_status === 'paid' && !isTeacher && !walletDisabled" small class="font-weight-medium black--text" dark label color="secondary">
                            <v-icon size="16" left class="me-1">mdi-wallet-outline</v-icon>
                            <span>Paid</span>
                        </v-chip>
                    </div>
                </div>
                <div>
                    <v-btn v-if="classData.recording_url" color="primary" small style="text-transform: capitalize;" class="recording-flash" :href="classData.recording_url" target="_system">
                        <v-icon left size="18" class="me-1">mdi-file-video</v-icon>
                        <span>Recording</span>
                    </v-btn>
                    <div v-if="classData.recordings && classData.recordings.length" class="d-flex justify-end align-center flex-wrap">

                        <v-btn v-for="(recording, i) in classData.recordings" :key="recording.id" color="primary" small style="text-transform: capitalize;" :href="recording.url" target="_system" class="ms-1 mb-1 recording-flash">
                            <v-icon left size="18" class="me-1">mdi-file-video</v-icon>
                            <span>Recording {{ classData.recordings.length > 1 ? ' #' + (i+1) : '' }}</span>
                        </v-btn>
                    </div>
                </div>
            </div>
            
            <div class="d-flex align-center py-2">
                <div class="overflow-hidden">
                    <div v-if="isTeacher" class="strong-text--text font-weight-medium nowrap">{{ classData.is_program_class ? 'Group Class' : (classData.enrollment && classData.enrollment.student ? classData.enrollment.student.name : '') }}</div>
                    <div v-else class="strong-text--text font-weight-medium nowrap">{{ classData.teacher ? classData.teacher.name : '' }}</div>
                    <router-link :to="isStudent ? (classData.is_program_class ? (classData.program ? {name: 'program', params: {id: classData.program.id}} : '') : (classData.enrollment && classData.enrollment.course ? {name: 'course', params: {id: classData.enrollment.course.id}} : '')) : ''">
                        <div class="details-text muted--text text--darken-1">{{classData.name || (classData.is_program_class ? (classData.program ? classData.program.name : 'Program Class') : (classData.enrollment && classData.enrollment.course ? classData.enrollment.course.name : ''))}}</div>
                    </router-link>
                    <div v-if="isTeacher && classData.student_timezone" class="details-text muted--text">
                        Time now in student's timezone ({{classData.student_timezone}}):
                        <div class="text--text">
                            <timezone-clock :timezone="classData.student_timezone" />
                        </div>
                    </div>
                </div>
            </div>
            <v-divider class="my-1"></v-divider>
            <div>
                <div class="medium-text text--text mb-1" style="font-weight: 500">
                    <v-icon color="text" size="18" class="me-1">mdi-calendar</v-icon> 
                    <span>{{ classDateFormated }}</span>
                </div>
                <div class="d-flex align-center mb-1">
                    <div class="px-2 py-1 primary--text" style="font-weight: 500; border: 2px solid; border-radius: 10px;">{{startTime}}</div>
                    
                    <template v-if="isTeacher || classData.status === 'running'">
                        <div class="font-weight-bold mx-2">:</div>
                        <div class="px-2 py-1 strong-text--text" style="border: 1px solid; border-radius: 10px;">{{ endTime }}</div>
                    </template>
                </div>
                <div v-if="!classData.canceled && classData.status !== 'expired' && classData.status !== 'running'" class="details-text muted--text">
                    <v-icon color="muted" size="15">mdi-timer-sand</v-icon>
                    Remaining: 
                    <span :class="{'primary--text font-weight-bold': isSoon, 'text--text': !isSoon}">{{ countdownTime }}</span>
                </div>
            </div>
            <div style="line-height: normal!important;" v-if="classData.class_report_evaluation">
                <v-divider class="my-2"></v-divider>
            
                <div>Class Evaluation</div>
                <div>
                    <strong class="details-text primary--text">{{ classData.class_report_evaluation }}</strong>
                </div>
            </div>
            <v-divider class="my-3"></v-divider>
            <div class="alerts">
                <v-alert v-if="classData.canceled && classData.cancelation_reason" dense small text dark  color="error darken-1" class="px-3 mt-3">
                    <div class="details-text font-weight-medium strong-text--text e-scrollbar" style="max-height: 100px; overflow-y: auto;">
                        <v-icon color="error darken-2" size="18" class="me-1">mdi-close-circle-outline</v-icon>
                        <span class="error--text text--darken-2">cancelation reason:</span>
                        <br>
                        <span class="details-text font-weight-medium" style="white-space: pre-line;">{{classData.cancelation_reason}}</span>
                    </div>
                </v-alert>
                <div v-if="classData.status !== 'expired' && classData.payment_status === 'balance-not-enough' && !walletDisabled" class=" mt-3">
                    <router-link v-if="isStudent" :to="{name: 'wallet'}" style="text-decoration: none">
                        <v-alert dense small color="error darken-1" text type="error" class="e-link px-3 mb-0" v-ripple>
                            <div class="details-text font-weight-medium">
                                <b>Balance Not Enough, please recharge...</b>
                                <br>
                            </div>
                        </v-alert>
                    </router-link>
                    <v-alert v-else dense small text type="error" color="orange darken-2" class="px-3 mb-0">
                        <div class="details-text font-weight-medium">
                            <b>Student doesn't have enough balance</b>
                        </div>
                    </v-alert>
                </div>
            </div>

            <div v-if="classData.attended && classData.status !== 'running' && classData.status !== 'scheduled' && !isTeacher && !classData.is_program_class">
                <v-btn v-if="!classData.student_feedback_rating" outlined color="primary" block @click="studentFeedbackDialog = true;">
                    <v-icon left size="20">mdi-star-shooting-outline</v-icon>
                    How was your class?
                </v-btn>
                <div v-else>
                    <div class="medium-text muted--text">Your feedback:</div>
                    <v-rating v-model="classData.student_feedback_rating" color="primary" half-increments background-color="muted lighten-2" readonly dense hover length="5" size="28" half-icon="mdi-star-half-full" ></v-rating>
                </div>
            </div>
        </div>
        <v-card-actions class="d-flex flex-column pa-4 pt-2" >
            <template v-if="isTeacher && !classData.editable && !classData.canceled && classData.id && classData.status !== 'expired'">
                <v-btn v-if="classData.url_editable && !classData.join_url_added" color="green darken-1" depressed :loading="creatingClassroom" block class="white--text mb-2" @click.prevent="createClassroom()">
                    <v-icon left class="me-3">mdi-laptop-account</v-icon>
                    Create Classroom
                </v-btn>
                <v-btn color="green darken-1" depressed :loading="joining" :disabled="!classData.joinable || classData.status === 'expired'" block class="white--text mb-2" @click.prevent="joinClass(classData.id)">
                    <v-icon left class="me-3">mdi-login</v-icon>
                    Join Classroom
                </v-btn>
            </template>
            <template v-if="classData.editable && !classData.is_program_class">
                <v-btn color="indigo darken-1" outlined :loading="rescheduling" :disabled="!!classData.waiting_reschedule_request" depressed block class="white--text" @click="rescheduleDialog = true; rescheduleDate = classData.date">
                    <v-icon left>mdi-clock-edit</v-icon>
                    reschedule
                </v-btn>
                <v-btn :disabled="classData.canceled" outlined :loading="canceling" color="muted" depressed block class="mx-0 mt-2 white--text" @click="cancelDialog = true">
                    <v-icon left>mdi-close</v-icon>
                    Cancel
                </v-btn>
            </template>
            <div v-else-if="isStudent && !classData.canceled && !classData.absent && classData.id && classData.status !== 'expired'" class="w-100">

                <v-btn color="green darken-1" depressed :loading="joining" :disabled="!classData.joinable || classData.status === 'expired'" large block class="white--text" @click.prevent="joinClass(classData.id)">
                    <v-icon left class="me-3">mdi-login</v-icon>
                    Join Classroom
                </v-btn>
                <v-btn type="a" v-if="temporarilyJoinUrl" :target="capRunning ? '_system' : '_blank'" :href="temporarilyJoinUrl" small block text class="mt-2 " style="text-transform: none">Or Click here</v-btn>
                <div v-if="classData.status === 'running' && !classData.joinable" class="details-text font-weight-medium strong-text--text mt-2">
                    <v-icon size="18" color="primary">mdi-progress-clock</v-icon>
                    Please wait until your teacher join...
                </div>
                <div v-else-if="!classData.editable" class="details-text font-weight-medium strong-text--text mt-2">
                    <v-icon size="18" color="muted">mdi-information-outline</v-icon>
                    You can't cancel or reschedule this class
                </div>
            </div>

            <div v-if="isTeacher && classData.can_mark_attended && classData.status !== 'scheduled' && (!classData.attended || classData.is_program_class) && !classData.absent" class="w-100">
                <v-btn v-if="!classData.has_class_report && classData.payment_status !== 'balance-not-enough'" color="primary" depressed :loading="attendedLoading" block @click="addReportDialog = true" class="mb-2">
                    <v-icon left class="me-3">mdi-file-account-outline</v-icon>
                    <span>Class Report</span>
                </v-btn>
                <template v-if="!classData.is_program_class">
                    <v-btn v-if="classData.has_class_report" :disabled="!classData.has_class_report || classData.attended || classData.payment_status === 'balance-not-enough'" color="success" depressed :loading="attendedLoading" large block class="mb-2" @click="attendedDialog = true">
                        <v-icon left class="me-3">mdi-check-circle-outline</v-icon>
                        Completed
                    </v-btn>
                    <v-btn :disabled="classData.absent || classData.payment_status === 'balance-not-enough'" color="black" depressed :loading="absentLoading" outlined block @click="absentDialog = true" class="mb-2">
                        <v-icon left class="me-3">mdi-account-remove</v-icon>
                        Absent
                    </v-btn>
                </template>
            </div>
        </v-card-actions>

        <v-dialog transition="slide-y-transition" v-model="absentDialog" max-width="350">
            <v-card>
                <v-card-title>Confirmation</v-card-title>
                <v-card-text>
                    Mark this class as absent...
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" @click="absentDialog = false">Cancel</v-btn>
                    <v-btn text color="red" @click="markAsAbsent">Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog transition="slide-y-transition" v-model="attendedDialog" max-width="350">
            <v-card>
                <v-card-title>Confirmation</v-card-title>
                <v-card-text>
                    Mark this class as completed
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" @click="attendedDialog = false">Cancel</v-btn>
                    <v-btn text color="success" @click="markAsAttended">Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog transition="slide-y-transition" v-model="studentFeedbackDialog" max-width="525" :fullscreen="phoneOnly" :fluid="phoneOnly">
            <v-card :class="{'fill-height': phoneOnly}" :style="`${iosSafeArea ? 'padding-top: 45px!important; ' : ''}`">
                <v-card-title class="mb-1">Class Feedback</v-card-title>
                <v-card-text>
                    <v-form ref="feedbackForm">
                        <div class="medium-text text--text ms-2">How was your class?</div>
                        <div class="mb-4">
                            <v-rating v-model="studentFeedbackForm.student_feedback_rating" color="primary" half-increments background-color="muted lighten-2" hover length="5" size="28" half-icon="mdi-star-half-full" ></v-rating>
                        </div>
                        <v-textarea v-model="studentFeedbackForm.student_feedback_text" filled label="Feedback (optional)" :disabled="savingClassReport" rows="4"></v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="savingFeedback" @click="studentFeedbackDialog = false">Cancel</v-btn>
                    <v-btn text color="primary" :disabled="savingFeedback" @click="saveStudentFeedback">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-if="isTeacher && classData.can_mark_attended" transition="slide-y-transition" v-model="addReportDialog" max-width="525" :fullscreen="phoneOnly" :fluid="phoneOnly">
            <v-card :class="{'fill-height': phoneOnly}" :style="`${iosSafeArea ? 'padding-top: 45px!important; ' : ''}`">
                <v-card-title class="mb-1">Class Report</v-card-title>
                <v-card-text>
                    <v-form ref="addReportForm">
                        
                        <v-select v-model="reportForm.evaluation" filled label="Evaluation" :items="['Excellent', 'Good', 'Needs improvement']" :disabled="savingClassReport" :menu-props="{offsetY: true}"></v-select>
                        <v-textarea v-model="reportForm.lesson_summary" filled label="Lesson Summary" :disabled="savingClassReport" rows="4"></v-textarea>
                        <v-textarea v-model="reportForm.notes" filled label="Notes & Recommendations" :disabled="savingClassReport" rows="4"></v-textarea>
                        <v-text-field v-if="appData.allow_manual_recording_url" v-model="reportForm.recording_url" prepend-inner-icon="mdi-file-video" filled label="Recording URL" :disabled="savingClassReport"></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="savingClassReport" @click="addReportDialog = false">Cancel</v-btn>
                    <v-btn text color="primary" :disabled="savingClassReport" @click="saveClassReport">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog transition="slide-y-transition" v-model="cancelDialog" max-width="400">
            <v-card>
                <v-card-title>Class Cancel</v-card-title>
                <v-card-text>
                    <div v-if="isTeacher">
                        
                    </div>
                    <div v-else>
                        <v-alert v-if="classData.available_class_changes || classData.available_class_changes === 0" dense small text :color="classData.available_class_changes === 0 ? 'red' : 'muted'" class="px-3">
                            <div class="primary--text text--darken-1 medium-text">
                                Remaining <b>{{classData.available_class_changes}} times</b> from {{classData.monthly_class_changes}} to cancel or reschedule this month
                            </div>
                        </v-alert>
                        
                        <v-alert type="info" color="grey darken-1" outlined>
                            <div class="details-text font-weight-medium">
                                <b>Note:</b> You'll not be charged for this class, but you can't undo this action.
                            </div>
                        </v-alert>
                    </div>

                    <div class="mt-5">
                        <v-textarea v-model="cancelationReason" placeholder="Reason *" color="error darken-1" filled hide-details no-resize auto-grow rows="4" class="medium-text"></v-textarea>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" @click="cancelDialog = false">Cancel</v-btn>
                    <v-btn text color="red" :disabled="classData.limit_exceeded" @click="cancelClass">Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog transition="slide-y-transition" v-model="rescheduleDialog" max-width="400">
            <v-card>
                <v-card-title class="mb-2">Reschedule Class</v-card-title>
                <v-card-text>
                    <template v-if="!isTeacher">
                        <v-alert v-if="classData.available_class_changes || classData.available_class_changes === 0" dense small text :color="classData.available_class_changes === 0 ? 'red' : 'muted'" class="px-3">
                            <div class="primary--text text--darken-1 medium-text">
                                Remaining <b>{{classData.available_class_changes}} times</b> from {{classData.monthly_class_changes}} to cancel or reschedule this month
                            </div>
                        </v-alert>
                    </template>
                    <v-form v-if="!classData.limit_exceeded">
                         <v-menu ref="menu" v-model="rescheduleDateMenu" :close-on-content-click="false" :return-value.sync="rescheduleDate" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="rescheduleDate" placeholder="Date" color="indigo" label="Class Date" filled hide-details :disabled="rescheduling" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker color="indigo" v-model="rescheduleDate" :min="minRescheduleDate" :max="maxRescheduleDate" no-title scrollable>
                                
                            </v-date-picker>
                        </v-menu>

                        <div class="mt-4">
                            <time-input v-model="rescheduleTime" half-format filled label="Time" placeholder="Class Time" color="indigo" :disabled="rescheduling" />
                        </div>

                        <div class="mt-4">
                            <v-select v-model="permanentReschedule" label="One-Time or Permanent" color="indigo" :items="[{text: 'One-time', value: false}, {text: 'Permanent Reschedule', value: true}]" filled hide-details :disabled="rescheduling" ></v-select>
                        </div>

                        <div class="mt-5">
                            <v-textarea v-model="rescheduleReason" filled auto-grow rows="4" placeholder="Reason *" color="indigo darken-1" hide-details no-resize class="medium-text" :disabled="rescheduling"></v-textarea>
                        </div>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" @click="rescheduleDialog = false">Cancel</v-btn>
                    <v-btn text color="indigo" :disabled="classData.limit_exceeded || rescheduling" :loading="rescheduling" @click="rescheduleClass">Reschedule</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import TimeInput from '@/components/custom/time-input'
import TimezoneClock from '@/components/default/timezone-clock'
import { template } from 'lodash'


export default {
    components: {TimeInput, TimezoneClock},
    data(){
        const min = new Date();
        min.setDate(min.getDate());

        const max = new Date();
        max.setDate(max.getDate()+14);

        return {
            joining: false,
            temporarilyJoinUrl: '',
            
            creatingClassroom: false,

            studentFeedbackDialog: false,
            savingFeedback: false,
            studentFeedbackForm: {
                student_feedback_rating: '',
                student_feedback_text: '',
            },

            absentDialog: false,
            absentLoading: false,
            
            attendedDialog: false,
            attendedLoading: false,

            cancelDialog: false,
            canceling: false,
            cancelationReason: '',

            addReportDialog: false,
            savingClassReport: false,
            reportForm: {
                evaluation: '',
                lesson_summary: '',
                notes: '',
                recording_url: ''
            },

            rescheduleDialog: false,
            rescheduling: false,
            rescheduleDateMenu: false,
            rescheduleDate: '' ,
            rescheduleTime: '' ,
            permanentReschedule: false,
            rescheduleReason: '',

            minRescheduleDate: min.toISOString().substr(0, 10),
            maxRescheduleDate: max.toISOString().substr(0, 10),

            intervalid: null,
            timeAgo: '',
            timeNow: '',
            countdownTime: '',
            startsInSeconds: null,
        }
    },
    props: {
        classData: {},
        reloading: {type: Boolean, default: false},
        noDialog: {type: Boolean, default: false},
    },
    computed: {
        startTime(){
            // const d = new Date(this.classData.start);
            // const timeString = d.toLocaleTimeString();
            // const times = timeString.split(' ')[0].split(':');
            // return `${times[0]}:${times[1]} ${timeString.split(' ')[1]}`

            const t = new Date(this.classData.start);
            return this.formatTime(t);
        },
        endTime(){
            const t = new Date(this.classData.end);
            return this.formatTime(t);
        },
        classDateFormated(){
            const t = new Date(this.classData.start)
            const options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' };
            return t.toLocaleDateString("en-US", options);
        },
        isSoon(){
            if (!this.startsInSeconds){
                return false;
            }
            const hours = this.startsInSeconds / 3600;
            return hours < 12;
        },
        ...GlobalComputed
    },
    methods: {
        joinClass(id){
            if (!this.joining){
                this.joining = true;
                this.$store.dispatch('joinClass', {id}).then(response=>{
                    this.joining = false;

                    const url = response.data.join_url;
                    window.setTimeout(()=>{
                        // window.open(url, '_system');
                        this.openLink(url);
                        this.setTemporarilyJoinUrl(url);
                    }, 300);

                    this.showClassDialog = false;

                }).catch(e=>{
                    this.joining = false;
                    this.showMsg('Error occurred during joining, please contact support', 'error');
                })
            }
        },
        setTemporarilyJoinUrl(url){
            this.temporarilyJoinUrl = url;
            window.setTimeout(()=>{
                this.temporarilyJoinUrl = '';
            }, 7000);
        },
        formatTime(t, isTimestamp=false){
            if (isTimestamp){
                t = new Date(t);
            }
            let hours = t.getHours(), 
                minutes = t.getMinutes() + '', 
                ampm = 'AM';

            if(hours > 11){
                hours = hours - 12;
                ampm = 'PM';
            }

            if(hours == 0) hours = 12;
            if(minutes.length == 1) minutes = '0' + minutes;

            return `${hours}:${minutes} ${ampm}`;
        },
        openLink(url){
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.setAttribute('target', '_system');
            a.click();
            document.body.removeChild(a);
        },
        createClassroom(){
            const id = this.classData.id;
            if (!this.creatingClassroom){
                this.creatingClassroom = true;
                this.$store.dispatch('createClassroom', {id}).then(response=>{
                    this.creatingClassroom = false;
                }).catch(e=>{
                    this.creatingClassroom = false;
                    console.error(e);
                    this.showMsg('Error occurred during preforming your action', 'error');
                })
            }
        },
        markAsAbsent(){
            const id = this.classData.id;
            if (!this.absentLoading){
                this.absentDialog = false;
                this.absentLoading = true;
                this.$store.dispatch('markAsAbsent', {id}).then(response=>{
                    this.absentLoading = false;
                }).catch(e=>{
                    this.absentLoading = false;
                    this.showMsg('Error occurred during preforming your action', 'error');
                })
            }
        },
        markAsAttended(){
            const id = this.classData.id;
            if (!this.attendedLoading){
                this.attendedDialog = false;
                this.attendedLoading = true;
                this.$store.dispatch('markAsAttended', {id}).then(response=>{
                    this.attendedLoading = false;
                }).catch(e=>{
                    this.attendedLoading = false;
                    this.showMsg('Error occurred during preforming your action', 'error');
                })
            }
        },
        saveClassReport(){
            const id = this.classData.id;
            if (!this.savingClassReport){
                this.savingClassReport = true;
                const data = this.reportForm;
                this.$store.dispatch('saveClassReport', {id, data}).then(response=>{
                    this.savingClassReport = false;
                    this.addReportDialog = false;
                    // this.showMsg('Class Report Saved Successfully', 'success');
                }).catch(error=>{
                    this.savingClassReport = false;
                    if (error.response && error.response.status === 422){
                        // coming errors from backend
                        let errors = error.response.data.errors;
                        this.showMsg(errors[Object.keys(errors)[0]][0]);
                    }else{
                        this.showMsg('Error occurred during preforming your action', 'error');
                    }
                })
            }
        },
        saveStudentFeedback(){
            const id = this.classData.id;
            if (!this.savingFeedback){
                this.savingFeedback = true;
                const data = this.studentFeedbackForm;
                this.$store.dispatch('saveClassFeedback', {id, data}).then(response=>{
                    this.savingFeedback = false;
                    this.studentFeedbackDialog = false;
                    this.showMsg('Thanks for your feedback', 'success');
                }).catch(e=>{
                    this.savingFeedback = false;
                    this.showMsg('Error occurred during preforming your action', 'error');
                })
            }
        },
        cancelClass(){
            const id = this.classData.id;
            this.cancelDialog = false;
            if (!this.canceling){
                this.canceling = true;
                const data = {
                    cancelation_reason: this.cancelationReason
                };

                this.$store.dispatch('cancelClass', {id, data}).then(response=>{
                    this.canceling = false;
                }).catch(e=>{
                    this.canceling = false;
                    if (e && e.response && e.response.data === 'LIMIT_EXCEEDED'){
                        this.showMsg('Monthly limit exceeded', 'error');
                    }else if (e && e.response && e.response.data && e.response.data.message){
                        this.showMsg(e.response.data.message, 'error');
                    }else{
                        this.showMsg('Error occurred during preforming your action', 'error');
                    }
                })
            }
        },
        rescheduleClass(){
            if (this.rescheduleTime && this.rescheduleDate){
                const id = this.classData.id;
                if (!this.rescheduling){
                    this.rescheduling = true;
                    this.$store.dispatch('rescheduleClass', {id, date: this.rescheduleDate, time: this.rescheduleTime, permanent: this.permanentReschedule, reason: this.rescheduleReason}).then(response=>{
                        this.rescheduleDialog = false;
                        this.rescheduling = false;
                        this.showMsg('Reschedule request submitted', 'success');
                    }).catch(e=>{
                        this.rescheduling = false;
                        
                        if (e && e.response && e.response.data === 'LIMIT_EXCEEDED'){
                            this.showMsg('Monthly limit exceeded', 'error');
                        }else if (e && e.response && e.response.data && e.response.data.message){
                            this.showMsg(e.response.data.message, 'error');
                        }else{
                            this.showMsg('Error occurred during preforming your action', 'error');
                        }
                    })
                }
            }else{
                this.showMsg('inputs are required', 'error');
            }
        },
        setTimeIntervals(time) {
            const self = this;
            self.setDowntimer(time);
            self.timeAgo = self.timeSince(time, true);

            // update time every 1s
            this.intervalid = setInterval(function () {
                self.timeAgo = self.timeSince(time, true);
                self.setDowntimer(time);
            }, 1000);
        },
        timeNowHandler(){
            var date = new Date();
            var h = date.getHours(); // 0 - 23
            var m = date.getMinutes(); // 0 - 59
            var s = date.getSeconds(); // 0 - 59
            var session = "AM";
            
            if(h == 0){
                h = 12;
            }
            
            if(h >= 12){
                session = "PM";
                if (h > 12){
                    h = h - 12;
                }
            }
            
            h = (h < 10) ? "0" + h : h;
            m = (m < 10) ? "0" + m : m;
            s = (s < 10) ? "0" + s : s;
            
            this.timeNow = h + ":" + m + ":" + s + " " + session;
            
            window.setTimeout(this.timeNowHandler, 1000);
        },
        setDowntimer(time){
            let now = + new Date(), // + new Date() = date.valueOf() | it is a timestamp
                start = new Date(time),
                difference = start.valueOf() - now;
            if (difference > 0){
                let days = Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                    minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
                    seconds = Math.floor((difference % (1000 * 60)) / 1000);
    
                // this.countdownTime = `${days ? days + ' ' : ''}${hours<10 ? '0' + hours : hours}:${minutes<10 ? '0'+minutes : minutes}:${seconds<10 ? '0' + seconds : seconds}`
                
                let countdownTime = '';
                if (days) countdownTime += `${days} days and `;
                if (hours) countdownTime += `${hours} hours `;
                if (minutes && !days){
                    if (hours){
                        countdownTime += `and ${minutes} minutes`
                    }else{
                        countdownTime += `and ${minutes} minutes and `
                    }
                }
                if (!days && !hours){
                    if (seconds >= 0) countdownTime += `${seconds} seconds`;
                }
                this.countdownTime = countdownTime;
                this.startsInSeconds = Math.floor(difference / 1000);
            }
        },
        ...GlobalMethods
    },
    watch: {
        classData(){
            if (this.intervalid){
                window.clearInterval(this.intervalid);
            }
            this.setTimeIntervals(this.classData.start);
        },
        rescheduleDate(date){
            this.$refs.menu.save(date)
        }
    },
    mounted(){
        this.setTimeIntervals(this.classData.start);
        this.timeNowHandler();
    },
    beforeDestroy(){
        if (this.intervalid){
            window.clearInterval(this.intervalid);
        }
    }
};
</script>

<style scoped>
.recording-flash {
    animation: recording-flash 2s ease infinite;
}

@keyframes recording-flash {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.75;
        box-shadow: none;
    }
    100% {
        opacity: 1;
    }
}

@media (prefers-reduced-motion: reduce) {
    .recording-flash {
        animation: none;
    }
}
</style>